const services = {
	"tbi": require("./TBI.js"),
	"unicredit": require("./UniCredit.js"),
	"bnp": require("./BNP.js"),
	"dsk": require("./DSK.js"),
};

// const availablePeriods = [ 3, 6, 9, 12, 15, 18, 24, 36 ];

class Leasing {

	constructor(company) {
		this._company = services[company];
		this._period  = null;
		this._price   = null;
		this._companyKey = company;
	}

	period(period) {
		this._period = period;
		return this;
	}

	price(price) {
		this._price = price;
		return this;
	}

	total() {
		return this._company.total(this._period, this._price);
	}

	perMonth() {
		return this._company.perMonth(this._period, this._price);
	}
	
	annualInterestRate() {
		return this._company.annualInterestRate(this._period, this._price);
	}

	annualPercentageRate() {
		return this._company.annualPercentageRate(this._period, this._price);
	}
	
	company() {
		return this._company;
	}
};

module.exports = {

	get(company = "unicredit") {
		return new Leasing(company);
	},

	getAll() {
		var companies = Object.keys(services);
		var result = {};

		for (var i = 0, len = companies.length; i < len; i++) {
			var company = companies[i];

			result[company] = new Leasing(company);
		}

		return result;
	},


	// getAvailablePeriods() {
	// 	return availablePeriods;
	// }

}